import { apiClient } from "./apiClient";

export const fetchClaimsDetailDataCarrier = async (code) => {
    try {
        const response = await apiClient.get(`/carrier/claimdetail?code=${code}`);
        return response.data;
    } catch (error) {
        throw error;
    }
}